


import React, { useEffect, useState } from "react";
import axios from "axios";
import CategorySection from "../HomePage/CategorySection";


const BASE_URL = "https://ecom.cyberathon.com";

function DetailsSection2dynamic() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [catRes, prodRes] = await Promise.all([
        axios.get(`${BASE_URL}/index.php/Api/list_category`),
        axios.get(`${BASE_URL}/index.php/Api/list_get_product`)
      ]);

      setCategories(catRes.data.data || []);
      setProducts(prodRes.data.products || []);
    } catch (error) {
      console.error("Homepage data load error", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  /* ⭐ HOME PAGE CATEGORIES (ADMIN CONTROLLED) */
  const homeCategories = categories.filter(
    (cat) => Number(cat.show_on_details) === 1
  );

  return (
    <>
      {homeCategories.length === 0 && (
        <div className="text-center py-4">
          No categories enabled for homepage
        </div>
      )}

      {homeCategories.map((category) => {
        const catProducts = products.filter(
          (product) =>
            String(product.category_id) === String(category.category_id)
        );

        if (catProducts.length === 0) return null;

        return (
          <CategorySection
            key={category.category_id}
            title={category.category_name}
            products={catProducts.slice(0,4)}
            categoryId={category.category_id}
          />
        );
      })}
    </>
  );
}

export default DetailsSection2dynamic;
